


import { controls } from "../../controls";


const securitydetails = {
  label: "Cash Credit Renewal",
  pageLabel: "Cash Credit Renewal",
  starting: true,
  url: "securitydetails",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...controls.displayText({ label: "Security", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Security", name: "security", width: "col-sm-2" }),

    ...controls.displayText({ label: "Given Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "given_date" }),

    ...controls.displayText({ label: "Security Type", width: "col-sm-2" }),
    ...controls.select({ width: "col-sm-2", name: "security_type" ,options: [{
        label: "Primary",
        value: "primary"
      },
      {
        label: "Colateral",
        value: "colateral"
      }]}),
    ...controls.displayText({ label: "Description", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Description", name: "description", width: "col-sm-2" }),
    ...controls.displayText({ label: "Value", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Value", name: "value", width: "col-sm-2" }),
    ...controls.displayText({ label: "Percent", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Percent", name: "percent", width: "col-sm-2" }),
    ...controls.displayText({ label: "Secured Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ placeHolder: "Secured Amount", name: "secured_amount", width: "col-sm-2" }),  
    ...controls.displayText({ label: "Due Date", width: "col-sm-2" }),
    ...controls.datePicker({ width: "col-sm-2", name: "due_date" }),
    

    ...controls.button({
      label: "ADD", onclick: {
        action: "appendToHTMLTable",
        tableNameField: 'securitydetails_table',
        requiredField: ["security", "given_date", "security_type", "description", "value", "percent","secured_amount","due_date"]
      }, width: "col-sm-2"
    }),
    {
      inputType: "table",
      tableTitle: "",
      // convertedTo: "nominee_table",
      deletable: true,
      // editable: true,
      // addRows: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Security", field: "security"},
        { label: "Given Date", field: "given_date",displaytype: 'date'},
        { label: "Security Type", field: "security_type"},
        { label: "Description", field: "description", },
        { label: "Value", field: "value" },
        { label: "Percent", field: "percent" },
        { label: "Secured Amount", field: "secured_amount",displaytype: 'currency' },
        { label: "Due Date", field: "due_date" ,displaytype: 'date'},
        // { label: "Given Date", field: "given_date" }
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "securitydetails_table"
    },
  ]
}

export default securitydetails;